import React, { useState } from 'react'

import { Container } from '../../components/Container'
import { Tab, Tabs } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { Additions } from './Additions'
import { useKPI } from '../../hooks/useKPI'
import { Inspections } from './Inspections'
import { Damages } from './Damages'
import { Invoices } from './Invoices'
import { Schedules } from './Schedules'
import { ChangeOrders } from './ChangeOrders'
import { Users } from './Users'
import { EZManage } from './EZManage'
import { Lori } from './Lori'
import { VendorTransitions } from './VendorTransitions'
import { MoveInInspections } from './MoveInInspections'
import { TurnProjects } from './TurnProjects'

export const KPIHome = () => {
    const theme = useTheme()

    const ADDITIONS = 0
    const DAMAGES = 1
    const INVOICES = 2
    const SCHEDULES = 3
    const INSPECTIONS = 4
    const CHANGE_ORDERS = 5
    const USERS = 6
    const EZMANAGE = 7
    const LORI = 8
    const VENDOR_TRANSITIONS = 9
    const MOVE_IN_INSPECTIONS = 10
    const TURN_PROJECTS = 11
    const [selectedTab, setSelectedTab] = useState<number>(ADDITIONS)
    const KPIController = useKPI()

    return (
        <Container
            style={{
                flex: 1,
                flexDirection: 'column',
                height: '100%',
                minHeight: 0,
                minWidth: 0,
                overflow: 'hidden',
            }}
        >
            {/* Tabs */}
            <Container>
                <Tabs
                    value={selectedTab}
                    onChange={(_, newValue) => setSelectedTab(newValue)}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="Additions" />
                    <Tab label="Damages" />
                    <Tab label="Invoices" />
                    <Tab label="Schedules" />
                    <Tab label="Inspections" />
                    <Tab label="Change Orders" />
                    <Tab label="Users" />
                    <Tab label="EZ Manage" />
                    <Tab label="Lori" />
                    <Tab label="Vendor Transitions" />
                    <Tab label="Move In Inspections" />
                    <Tab label="Turn Projects" />
                </Tabs>
            </Container>

            {/* Body */}
            <Container
                style={{
                    flex: 1,
                    flexDirection: 'column',
                    marginTop: theme.spacing(2),
                    minHeight: 0,
                    minWidth: 0,
                    overflow: 'hidden',
                }}
            >
                {selectedTab === ADDITIONS && (
                    <Additions KPIController={KPIController} />
                )}
                {selectedTab === INSPECTIONS && (
                    <Inspections KPIController={KPIController} />
                )}
                {selectedTab === DAMAGES && (
                    <Damages KPIController={KPIController} />
                )}
                {selectedTab === INVOICES && (
                    <Invoices KPIController={KPIController} />
                )}
                {selectedTab === SCHEDULES && (
                    <Schedules KPIController={KPIController} />
                )}
                {selectedTab === CHANGE_ORDERS && (
                    <ChangeOrders KPIController={KPIController} />
                )}
                {selectedTab === USERS && (
                    <Users KPIController={KPIController} />
                )}
                {selectedTab === EZMANAGE && (
                    <EZManage KPIController={KPIController} />
                )}
                {selectedTab === LORI && <Lori KPIController={KPIController} />}
                {selectedTab === VENDOR_TRANSITIONS && (
                    <VendorTransitions KPIController={KPIController} />
                )}
                {selectedTab === MOVE_IN_INSPECTIONS && (
                    <MoveInInspections KPIController={KPIController} />
                )}
                {selectedTab === TURN_PROJECTS && (
                    <TurnProjects KPIController={KPIController} />
                )}
            </Container>
        </Container>
    )
}
